<template>
  <div>
    <template v-if="type === 'unboxing'">
      <h4>內容物拍照：</h4>
      方便您查看商品顏色、形狀等與預期是否相符，讓您擁有商品在大陸階段時及時退貨給賣家的能力，以節省國際運費。<br>
      <br>
      服務內容：<br>
      拍照外包裝+拍照內包裝+商品正面<br>
      <br>
      PS:<br>
      1、此服務不會觸碰到商品本身，僅拍照商品正面。<br>
      2、內包裝有密封時不會進一步拆封拍照。<br>
      3、本身帶木架/木箱包裹若需要開箱拍攝內容物照片，會協助拆除木架/木箱，但無法恢復，如需重新打木架/木箱要另外付費相應的附加服務。<br>
    </template>
    <template v-else-if="type === 'ooba'">
      <h4>開箱驗貨：</h4>
      方便您了解商品是否存在質量問題，讓您擁有商品在大陸階段時及時退貨給賣家的能力，以節省國際運費。<br>
      <br>
      服務內容：<br>
      倉庫人員會檢查商品完整、是否全新、是否有瑕疵，並回報檢查結果，如有瑕疵會另外提供照片，如無瑕疵則不另外提供照片。<br>
      <br>
      PS:<br>
      1、此服務會小心接觸商品，僅檢查瑕疵，不會拍攝內容物照。<br>
      2、內包裝有密封時不會進一步拆封驗貨。<br>
      3、本身帶木架/木箱包裹若需要開箱檢查瑕疵，會協助拆除木架/木箱，但無法恢復，如需重新打木架/木箱要另外付費相應的附加服務。<br>
    </template>
    <template v-else-if="type === 'oobno'">
      <h4>確認型號：</h4>
      方便您了解商品型號是否正確，讓您擁有商品在大陸階段時及時退貨給賣家的能力，以節省國際運費。<br>
      <br>
      服務內容：<br>
      倉庫人員會檢查商品是否有型號、尺寸等標籤，並將不同型號拍攝照片提供，如無明確型號僅會拍攝商品外觀以供辨識。<br>
      <br>
      PS:<br>
      1、此服務會小心接觸商品，僅拍攝型號、尺寸標籤，不包含丈量尺寸、清點數量等服務。<br>
      2、內包裝有密封時不會進一步拆封拍照。<br>
      3、本身帶木架/木箱包裹若需要開箱拍照，會協助拆除木架/木箱，但無法恢復，如需重新打木架/木箱要另外付費相應的附加服務。<br>
    </template>
    <template v-else-if="type === 'vaPoweronTest'">
      <div class="poweron-test-text">
        <h4>通電測試服務</h4>
        <p class="poweron-test-intro">
          電器商品最怕寄回台灣後，才發現電壓不合、功能異常，甚至有安全疑慮；屆時若要退換，往往耗時又兩難。加購通電測試服務，即免費贈送開箱驗貨，出貨前由專人協助確認商品狀況並進行基礎檢測，為您把關每一個使用細節。
        </p>
        <div class="poweron-test-section-title">
          適用範圍
        </div>
        <p class="poweron-test-scope">
          本服務適用於拆箱後，只需插上插頭，或接上電源線、充電線即可進行測試的商品。半成品、DIY 組件，以及需組裝或加工後才能測試的商品，不提供本服務。
        </p>
        <div class="poweron-test-section-title">
          服務內容
        </div>
        <ol class="poweron-test-list">
          <li>
            <strong>免費贈送開箱驗貨</strong>
            <div>出貨前由專人協助開箱確認商品狀況，再進行後續通電測試。</div>
          </li>
          <li>
            <strong>110V 電壓確認</strong>
            <div>確認商品是否可於台灣 110V 電壓環境下正常通電。</div>
          </li>
          <li>
            <strong>基本功能測試</strong>
            <div>依商品類型檢查開關、運轉、顯示、加熱、照明等基本功能是否正常。</div>
          </li>
          <li>
            <strong>專業漏電檢測</strong>
            <div>協助檢測商品是否有漏電異常，為您、家人和貓咪多一份安全保障。</div>
          </li>
        </ol>
        <div class="poweron-test-section-title">
          貼心提醒
        </div>
        <p class="poweron-test-reminder">
          此服務為出貨前基礎檢測，並免費贈送開箱驗貨，可降低商品抵台後才發現異常、退換兩難的風險，讓您收到商品後使用更安心。
        </p>
      </div>
    </template>
    <template v-else-if="type === 'vaWrapBox'">
      <div class="wrap-box-text">
        <h4>加購紙箱：</h4>
        <p>有些商品的原廠包裝僅適合一般配送，面對跨境運送時，難免擔心碰撞、擠壓或外箱磨損。巧巧郎替你多做一步，為包裹加裝合適的紙箱並完成基本封箱，讓包裹多一層保護，降低因外包裝不足帶來的運送風險，寄送更安心。</p>
        <h4>服務內容</h4>
        <ol>
          <li>依包裹尺寸搭配合適紙箱</li>
          <li>協助完成裝箱及基本封箱</li>
          <li>提供更完整的外箱保護</li>
        </ol>
        <p>不需要另外準備紙箱，也不用擔心尺寸是否合適，交給巧巧郎處理，更方便、更省心。</p>
        <h4>費用說明</h4>
        <ul>
          <li>小型紙箱：NT$15／件</li>
          <li>中型紙箱：NT$25／件</li>
          <li>大型紙箱：NT$35／件</li>
          <li>特大型紙箱：NT$50／件</li>
          <li>長型紙箱：NT$25／件</li>
        </ul>
        <p>巧巧郎會依包裹尺寸搭配適用的紙箱，實際規格與加購費用以服務頁面顯示為準，讓你事前清楚了解、安心選擇。</p>
        <h4>貼心提醒</h4>
        <p>本服務包含紙箱、裝箱及基本封箱，不包含氣泡布、防撞材料等特殊防護包材。加箱後，包裹尺寸與重量可能增加，後續運費將依實際資料計算。</p>
        <p>如果商品需要加強保護，也可搭配其他附加服務，讓包裹在運送途中獲得更周全的防護。</p>
      </div>
    </template>
    <template v-else-if="type === 'specialNeed'">
      <h4>其他需求：</h4>
      若您有其他想請倉庫協助的事項，可加購此服務，並在備註中簡單說明需求。<br>
      我們會依實際情況協助處理，讓出貨前多一層確認，收到商品更安心。<br>
      <br>
      服務內容<br>
      <br>
      1. 需求備註確認<br>
      協助確認您填寫的需求內容，降低溝通落差。<br>
      <br>
      2. 出貨前協助處理<br>
      依商品狀況與倉庫流程，協助處理可安排的需求。<br>
      <br>
      貼心提醒<br>
      <br>
      若需求超出可協助範圍，會先與您確認後再處理。
    </template>
    <template v-else-if="type === 'stuffing'">
      <h4>填充氣柱袋：</h4>
      箱填充於包裹內部，包覆商品防止運送碰撞，如箱內無空間則會包覆於外箱，完成後將會重新秤重入庫。
    </template>
    <template v-else-if="type === 'woodenSpt'">
      <h4>打木架：</h4>
      附加服務申請後，隔天進行排程，大約需要兩個工作天左右完成，完成後將會重新秤重入庫。<br>
      計費方式：立方米 x 1.4<br>
      立方米：長 x 寬 x 高 (單位cm) ÷ 1,000,000 <br>
      <br>
      若在0.15立方米以下<br>
      打木架費用：NT$ 225 / 件<br>
      <br>
      若在0.15立方米以上<br>
      打木架費用：NT$ 1500 / 立方米<br>
      <br>
      扁平貨 >長100cm >高80cm &lt;寬30cm<br>
      打木架費用：NT$ 400 / 立方米<br>
    </template>
    <template v-else-if="type === 'woodenBox'">
      <h4>打木箱：</h4>
      附加服務申請後，將於隔天安排作業，約需 2 個工作天完成。完成後將重新秤重入庫。<br>
      <br>
      計費方式<br>
      未丈量長、寬、高尺寸的包裹：固定收費 NT$200／件<br>
      <br>
      已丈量長、寬、高尺寸的包裹，依計費體積收費：<br>
      計費體積＝長 × 寬 × 高（cm）÷ 1,000,000 × 1.4<br>
      <br>
      計費體積未滿 0.15m³：NT$300／件<br>
      計費體積達 0.15m³（含）以上：NT$2,000／m³<br>
      <br>
      扁平貨物<br>
      系統會先將包裹三邊尺寸由大到小排序。<br>
      當最長邊 ≥ 100cm、次長邊 ≥ 80cm、最短邊 ≤ 30cm 時，優先改以面積計費。<br>
      <br>
      計費面積＝最長邊 × 次長邊（cm）÷ 10,000<br>
      打木箱費用：NT$600／m²<br>
    </template>
    <template v-else-if="type === 'ippc'">
      <h4>原木燻蒸服務：</h4>
      原木進口規範十分嚴格，必須加工過的原木才能夠正常進口。<br>
      為保障貨品運送過程能保持完整，部分用戶會請賣家協助打好木架、木箱，如若使用到未加工過的原木材料，則會導致貨品無法正常進口，或是木架、木箱被強制拆除。<br>
      為避免此狀況發生，我們提供原木熏蒸加工服務，貨品可以保留原本的木架、木箱不必拆除便可正常進口台灣。<br>
      <br>
      服務內容：<br>
      倉庫人員會協助將包裹外箱加固用的木架、木箱熏蒸加工後蓋章。<br>
    </template>
    <template v-else-if="type === 'ctnLbl'">
      <h4>外箱標示拍照：</h4>
      倉庫人員會分別拍攝包裹快遞面單、外箱標示的產品型號以及外箱LOGO，方便您辨識貨物規格。<br>
      <br>
      ＊如外箱無標示產品型號或是LOGO，僅會提供包裹快遞面單照片。
    </template>
    <template v-else-if="type === 'tpBag'">
      <h4>更換透明袋：</h4>
      因應臺北港海關要求，海快包裹需使用紙箱或者透明袋包裝，不得使用有色麻布袋（編織袋）。<br>
      包裝不符規範會產生此筆拆袋整理費用。<br>
      <br>
      ＊空運無需考慮貨物包裝<br>
      ＊透明袋不包含在費用當中，倉庫會視情況免費提供。<br>
    </template>
    <template v-else-if="type === 'oobrm'">
      <h4>移除禁運品：</h4>
      將包裹中禁運品取出並進行銷毀，以便包裹能順利集運。
    </template>
  </div>
</template>
<script>
export default {
  props: {
    type: String,
  },
}
</script>

<style lang="postcss" scoped>
.wrap-box-text {
  line-height: 1.6;

  h4 {
    margin: 0 0 6px;
  }

  p, ol, ul {
    margin: 0 0 12px;
  }

  ol, ul {
    padding-left: 24px;
  }

  p:last-child {
    margin-bottom: 0;
  }
}

.poweron-test-text {
  line-height: 1.6;

  h4 {
    margin: 0 0 6px;
  }

  .poweron-test-intro {
    margin: 0 0 10px;
  }

  .poweron-test-scope {
    margin: 0 0 10px;
  }

  .poweron-test-section-title {
    margin-bottom: 4px;
    font-weight: 600;
  }

  .poweron-test-list {
    margin: 0 0 10px;
    padding-left: 24px;

    li {
      margin-bottom: 6px;
    }

    li:last-child {
      margin-bottom: 0;
    }

    strong {
      font-weight: 600;
    }
  }

  .poweron-test-reminder {
    margin: 0;
  }
}
</style>
